export enum CollectionRequestStatus {
  SCHEDULED_FOR_NOTIFICATION = 'SCHEDULED_FOR_NOTIFICATION',
  SCHEDULED = 'SCHEDULED',
  IN_REALIZATION = 'IN_REALIZATION',
  FEEDBACK_ALLOWED = 'FEEDBACK_ALLOWED',
  COMPLETED = 'COMPLETED',
  MISSED = 'MISSED',
  CANCELLED = 'CANCELLED',
}

/** Mirrors CollectionRequestStatus.TERMINAL_STATUSES on the API side - the policy refuses to cancel these. */
export const TERMINAL_COLLECTION_REQUEST_STATUSES: CollectionRequestStatus[] = [
  CollectionRequestStatus.COMPLETED,
  CollectionRequestStatus.MISSED,
  CollectionRequestStatus.CANCELLED,
];

/** Everything else: what the cancel button may be offered for. The time window is still the API's call. */
export const CANCELLABLE_COLLECTION_REQUEST_STATUSES: CollectionRequestStatus[] = Object.values(CollectionRequestStatus).filter(
  (status) => !TERMINAL_COLLECTION_REQUEST_STATUSES.includes(status),
);
